import { useEffect, useRef, useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight, FaCloudDownloadAlt } from "react-icons/fa";
import PrivateApi from "../../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import { useAuthState } from "../../../context/AuthContext";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaBookOpenReader } from "react-icons/fa6";


/**
 * 
 * @param {notifications} props array of notification objects 
 * @param {setNotifications} props setter for array list of notifications objects
 */
const NotificationModal = (props) => {

    const API = new PrivateApi();
    const { user } = useAuthState();
    const queryClient = useQueryClient();
    const [show, setShow] = useState(true);
    const [currentView, setCurrentView] = useState(0);
    const [isReadedLoading, setIsReadedLoading] = useState(false);
    const notificationsLength = props.notifications.length;
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            const images = contentRef.current.querySelectorAll("img");
            const links = contentRef.current.querySelectorAll("a");
            images.forEach(img => img.classList.add("img-fluid"));
            links.forEach(link => link.classList.add("link-energo"));
        }
    }, [currentView])

    const markReaded = () => {
        setIsReadedLoading(true);
        API.setRead_Notifications({id: props.notifications[currentView].id})
            .then(() => {
                if (user.x_is_house_management) {
                    queryClient.invalidateQueries("NOTIFICATIONS");
                } else {
                    if (notificationsLength > currentView + 1) setCurrentView(currentView +1);
                    else setShow(false);
                }
                setIsReadedLoading(false);
            })
    }

    const downloadFile = (e) => {
        e.preventDefault();
        const linkSource = props.notifications[currentView].notification.file;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = props.notifications[currentView].notification.file_name;
        downloadLink.click();
    }

    return (
        <Modal show={show} size="xl">
            <Modal.Body >
                <Row className="align-items-center">
                    <Col xs="12">
                        <h3>{props.notifications[currentView].notification.title}</h3>
                        {props.notifications[currentView].notification.show_date === true?
                            <p>{new Date(props.notifications[currentView].notification.created).toLocaleDateString('DE-de')}</p>
                            :null
                        }
                    </Col>
                </Row>
                <hr />
                <Row className="mt-4">
                    <Col xs="12">
                        <div ref={contentRef} dangerouslySetInnerHTML={{__html: props.notifications[currentView].notification.message}}></div>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xl="12" className="text-center">
                        {props.notifications[currentView].notification.file !== null &&
                            <Button 
                                onClick={e => downloadFile(e)}
                                style={{marginRight: "5px", width: 170}}
                                className="btn-energo rounded-pill">
                                <FaCloudDownloadAlt size={25} /> &nbsp;
                                Dokument
                            </Button>
                        }
                        <Button 
                            onClick={() => setShow(false)} 
                            style={{marginRight: "5px", width: 170}}
                            className="btn-secondary rounded-pill"
                            >
                                <MdOutlineWatchLater size={25}/> &nbsp;
                                Später lesen
                        </Button>
                        {isReadedLoading?
                            <Spinner animation="border" className="text-energo" />
                            :
                            <Button 
                                hidden={user.x_is_house_management}
                                style={{width: 170}}
                                onClick={() => markReaded()} 
                                className="btn-energo rounded-pill"
                            >
                                <FaBookOpenReader size="25" /> &nbsp;
                                Gelesen
                            </Button>
                        }
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col xl="12" className="text-center">
                        <button 
                            disabled={currentView === 0}
                            onClick={() => setCurrentView(currentView -1)}
                            className="btn btn-link"> <FaChevronLeft className="text-energo" size={30} /> </button>
                        <b className="text-energo">{currentView +1} von {notificationsLength}</b>&nbsp;
                        <button 
                            disabled={currentView +1 === notificationsLength}
                            onClick={() => setCurrentView(currentView +1)}
                            className="btn btn-link"> <FaChevronRight className="text-energo" size={30} /> </button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default NotificationModal;